import { z } from "zod";

export const FeedSourceType = {
	NATIVE: "native",
	JOB: "job",
	STUDENT_CENTRAL: "student_central",
} as const;

export type FeedSourceType = (typeof FeedSourceType)[keyof typeof FeedSourceType];

export const FEED_SOURCE_TYPES = Object.values(FeedSourceType) as readonly FeedSourceType[];

export const feedSourceTypeSchema = z.enum(FeedSourceType);
